// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1116":"ddbca85b","5341":"ddbca85b","5437":"ddbca85b","5765":"8caf20b7"}[chunkId] + ".chunk.css";
};